(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-columns"] && !Shopify.designMode) return;
  try {
    
  /*
   * <faq-accordion>
   *
   * Progressive enhancement only. The markup is <details>/<summary>, so the
   * accordion opens, closes, exposes its state to assistive tech and responds
   * to find-in-page with no JavaScript at all. This element adds the height
   * transition and takes over single-open behaviour so a closing panel can
   * animate (the native `name` attribute snaps siblings shut instantly).
   */
  if (!customElements.get('faq-accordion')) {
    class FaqAccordion extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
      }

      connectedCallback() {
        if (this.initialised) return;
        this.initialised = true;

        this.singleOpen = this.dataset.singleOpen === 'true';

        if (this.singleOpen) {
          // Hand exclusivity to JS so closes are animated. The attribute stays
          // in the HTML for the no-JS case.
          this.items.forEach((item) => item.removeAttribute('name'));
        }

        this.addEventListener('click', this.onClick);
        this.addEventListener('shopify:block:select', this.onBlockSelect);

        this.openFromHash();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      get items() {
        return Array.from(this.querySelectorAll(':scope > details.faq-item'));
      }

      get reducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      openFromHash() {
        if (!window.location.hash) return;
        let target = null;
        try {
          target = this.querySelector(window.location.hash);
        } catch (error) {
          return;
        }
        const details = target && target.closest('details.faq-item');
        if (details && this.contains(details) && !details.open) {
          this.open(details, { animate: false });
        }
      }

      onClick(event) {
        const summary = event.target.closest('summary.faq-question');
        if (!summary || !this.contains(summary)) return;

        const details = summary.parentElement;
        if (!details || details.tagName !== 'DETAILS') return;

        // Let genuine links inside a question behave like links.
        if (event.target.closest('a[href]')) return;

        event.preventDefault();

        const wrapper = this.wrapperFor(details);
        const isClosing = wrapper ? wrapper.faqClosing === true : false;

        if (details.open && !isClosing) {
          this.close(details);
        } else {
          this.open(details);
        }
      }

      onBlockSelect(event) {
        const details = event.target.closest('details.faq-item');
        if (details && !details.open) this.open(details, { animate: false });
      }

      wrapperFor(details) {
        return details.querySelector(':scope > .faq-answer-wrapper');
      }

      open(details, options) {
        const animate = !options || options.animate !== false;
        const wrapper = this.wrapperFor(details);

        if (this.singleOpen) {
          this.items.forEach((item) => {
            if (item !== details && item.open) this.close(item);
          });
        }

        const from = wrapper && wrapper.faqAnimation ? wrapper.getBoundingClientRect().height : 0;

        details.open = true;

        if (!wrapper) return;

        wrapper.faqClosing = false;

        if (!animate || this.reducedMotion) {
          this.cancel(wrapper);
          wrapper.style.height = '';
          return;
        }

        this.run(wrapper, from, wrapper.scrollHeight, () => {
          // Back to auto, so the panel reflows if the content or viewport changes.
          wrapper.style.height = '';
        });
      }

      close(details) {
        const wrapper = this.wrapperFor(details);

        if (!wrapper || this.reducedMotion) {
          if (wrapper) {
            this.cancel(wrapper);
            wrapper.style.height = '';
            wrapper.faqClosing = false;
          }
          details.open = false;
          return;
        }

        const from = wrapper.getBoundingClientRect().height;
        wrapper.faqClosing = true;

        this.run(wrapper, from, 0, () => {
          wrapper.faqClosing = false;
          wrapper.style.height = '';
          details.open = false;
        });
      }

      cancel(wrapper) {
        if (wrapper.faqAnimation) {
          wrapper.faqAnimation.cancel();
          wrapper.faqAnimation = null;
        }
      }

      run(wrapper, from, to, done) {
        this.cancel(wrapper);

        if (!wrapper.animate) {
          done();
          return;
        }

        wrapper.style.height = from + 'px';

        const animation = wrapper.animate(
          [{ height: from + 'px' }, { height: to + 'px' }],
          { duration: 350, easing: 'cubic-bezier(0.33, 1, 0.68, 1)' }
        );

        wrapper.faqAnimation = animation;

        animation.onfinish = () => {
          wrapper.faqAnimation = null;
          done();
        };

        animation.oncancel = () => {
          wrapper.faqAnimation = null;
        };
      }
    }

    customElements.define('faq-accordion', FaqAccordion);
  }

  } catch(e) { console.error(e); }
})();
})();
